import PropTypes from 'prop-types';
// @flow

import React, { Component } from 'react';

// -- actions
import { RestaurantMenuAction, RouteAction } from 'actions';

import { ViewUtils } from 'PMT/utils';
import SecurityContext from 'utils/permissions/SecurityContext';

// -- constants
import ViewConstants from 'constants/ViewConstants';

// -- entities
import Product from 'PMT/entities/menu/Product';

// -- views
import ImageLoader from 'PMT/components/ImageLoader';
import EnabledDisabledIcon from 'PMT/components/EnabledDisabledIcon';
import RowPricesView from 'components/order/RowPricesView';
import SortableList from 'PMT/components/SortableList';

class CategoryModalProductRow extends Component {

  static propTypes = {
    product: PropTypes.instanceOf(Product).isRequired,

    // parameters: Product
    onDeleteFromCategory: PropTypes.func.isRequired,

    currencyCode: PropTypes.string,

  };

  shouldComponentUpdate(nextProps) {
    return !nextProps.product.equals(this.props.product);
  }

  onDisplayDetail = () => {
    RouteAction.presentProductEdit(this.product);
  };

  onDeleteFromCategory = () => {
    this.props.onDeleteFromCategory(this.product);
  };

  get product() {
    return this.props.product;
  }

  get currencyCode(): string {
    return this.props.currencyCode;
  }


  render() {
    return (
      <div className="product_category_view__row pointer row">

        <div className="hidden-sm col-md-2 text-left">
          <ImageLoader
            src={this.product.image}
            className="product_category_view__row__image"
            placeholder={ViewConstants.Image.RestaurantMenu.NO_IMAGE_FOR_PRODUCT}
          />
        </div>

        <div
          className="col-xs-6 product_category_view__row__name"
          onClick={this.onDisplayDetail}
        >
          <h4>{this.product.name}</h4>
        </div>

        <div
          className="pointer col-xs-2 text-right"
          onClick={this.onDisplayDetail}
        >
          <RowPricesView
            prices={this.product.prices}
            currencyCode={this.currencyCode}
          />
        </div>


        {SecurityContext.restaurantMenu.canEdit() &&
          <div
            className="pointer col-xs-1 text-center product_category_view__row__remove"
            onClick={this.onDeleteFromCategory}
          >
            <i className="fa fa-trash" />
          </div>
        }

        {SecurityContext.restaurantMenu.canEdit() &&
          <div
            className="pointer col-xs-1 text-center product_category_view__row__drag"
          >
            <SortableList.DragHandle />
          </div>
        }
      </div>
    );
  }

}

export default CategoryModalProductRow;
